import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExportModalComponent } from "./export-modal/export-modal.component";
import { PipesModule } from "../pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AddColumnModalComponent } from "./add-column-modal/add-column-modal.component";
import { FilterDataModalComponent } from "./filter-data-modal/filter-data-modal.component";
import { TranslateModule } from "@ngx-translate/core";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgbAccordionModule, NgbDropdownModule, NgbNavModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { DeleteModalComponent } from "./delete-modal/delete-modal.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { FlatpickrModule } from "angularx-flatpickr";
import { ExportHistoryModalComponent } from "./export-history-modal/export-history-modal.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { CountUpModule } from "ngx-countup";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { CountryPhonecodeComponent } from "./country-phonecode/country-phonecode.component";
import { ApplicationMenuComponent } from "./application-menu/application-menu.component";
import { BookingDetailsModalComponent } from "./booking-details/booking-details.component";
import { BookingHistoryComponent } from "./booking-history/booking-history.component";
import { ContextMenuModule } from "@perfectmemory/ngx-contextmenu";
import { NgxPaginationModule } from "ngx-pagination";
import { SharedComponentsModule } from "../shared-components/shared-components.module";
import { OtpModalComponent } from "./otp-modal/otp-modal.component";
import { NgOtpInputModule } from "ng-otp-input";
import { ViewFareEstimateModalComponent } from "./view-fare-estimate-modal/view-fare-estimate-modal.component";
import { TripReassignModalComponent } from "./trip-reassign-modal/trip-reassign-modal.component";
import { FixFareTripModalComponent } from "./fix-fare-trip-modal/fix-fare-trip-modal.component";
import { CollapsibleFilterComponent } from "../collapsible-filter/collapsible-filter.component";
import { BookingStatusChangeConfirmationModalComponent } from "./booking-status-change-confirmation-modal/booking-status-change-confirmation-modal.component";
import { FeatherModule } from "angular-feather";
import { allIcons } from "angular-feather/icons";
import { SurgePriceModalComponent } from "./surge-price-modal/surge-price-modal.component";
import { BookingVehicleFilterModalComponent } from "./booking-vehicle-filter-modal/booking-vehicle-filter-modal.component";
import { CancellationPolicyModalComponent } from "./cancellation-policy-modal/cancellation-policy-modal.component";
import { BookingCartDetailsComponent } from "../quick-commerce-shared-components/booking-cart-details/booking-cart-details.component";
import { QuickCommerceSharedComponentsModule } from "../quick-commerce-shared-components/quick-commerce-shared-components.module";
import { WalletHistoryModalComponent } from "./wallet-history-modal/wallet-history-modal.component";
import { AddNewCardComponent } from "./add-new-card/add-new-card.component";
import { AddAmountModalComponent } from "./add-amount-modal/add-amount-modal.component";
import { DeliverySharedComponentsModule } from "../delivery-shared-components/delivery-shared-components.module";
import { DriverListModelComponent } from "./driver-list-model/driver-list-model.component";
import { DateTimePickerModalComponent } from "./date-time-picker-modal/date-time-picker-modal.component";
import { BookingPaymentModalComponent } from "./booking-payment-modal/booking-payment-modal.component";
import { PromoCodeModalComponent } from "./promo-code-modal/promo-code-modal.component";
import { BookForOtherModalComponent } from "./book-for-other-modal/book-for-other-modal.component";
import { IncomingCallModalComponent } from "./incoming-call-modal/incoming-call-modal.component";
import { QueuedCallsWidgetComponent } from "./incoming-call-modal/queued-calls-widget.component";
import { TripLogTimelineComponent } from "src/app/pages/users/logs/trip-log-timeline.component";
import { TripVehicleTrackComponent } from "./booking-details/trip-vehicle-track.component";
import { RouterModule } from "@angular/router";
import { RheroLogoComponent } from "../rhero-ui/rhero-logo.component";
import { RheroShellComponent } from "../rhero-ui/rhero-shell.component";
import { RheroPageHeaderComponent } from "../rhero-ui/rhero-page-header.component";
import { RheroStateComponent } from "../rhero-ui/rhero-state.component";

@NgModule({
  declarations: [
    ExportModalComponent,
    AddColumnModalComponent,
    FilterDataModalComponent,
    DeleteModalComponent,
    ExportHistoryModalComponent,
    EditProfileComponent,
    CountryPhonecodeComponent,
    ApplicationMenuComponent,
    BookingDetailsModalComponent,
    BookingHistoryComponent,
    OtpModalComponent,
    ViewFareEstimateModalComponent,
    TripReassignModalComponent,
    FixFareTripModalComponent,
    CollapsibleFilterComponent,
    BookingStatusChangeConfirmationModalComponent,
    SurgePriceModalComponent,
    BookingVehicleFilterModalComponent,
    CancellationPolicyModalComponent,
    WalletHistoryModalComponent,
    AddNewCardComponent,
    AddAmountModalComponent,
    DriverListModelComponent,
    DateTimePickerModalComponent,
    BookingPaymentModalComponent,
    PromoCodeModalComponent,
    BookForOtherModalComponent,
    IncomingCallModalComponent,
    QueuedCallsWidgetComponent,
    RheroShellComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    RheroLogoComponent,
    RheroPageHeaderComponent,
    RheroStateComponent,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ImageCropperModule,
    NgbNavModule,
    NgbAccordionModule,
    NgSelectModule,
    FlatpickrModule,
    NgbDropdownModule,
    NgApexchartsModule,
    CountUpModule,
    NgbTooltipModule,
    ContextMenuModule,
    NgxPaginationModule,
    SharedComponentsModule,
    NgOtpInputModule,
    FeatherModule.pick(allIcons),
    BookingCartDetailsComponent,
    QuickCommerceSharedComponentsModule,
    DeliverySharedComponentsModule,
    TripLogTimelineComponent,
    TripVehicleTrackComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ExportModalComponent,
    AddColumnModalComponent,
    FilterDataModalComponent,
    DeleteModalComponent,
    ExportHistoryModalComponent,
    EditProfileComponent,
    CountryPhonecodeComponent,
    ApplicationMenuComponent,
    BookingDetailsModalComponent,
    BookingHistoryComponent,
    OtpModalComponent,
    ViewFareEstimateModalComponent,
    TripReassignModalComponent,
    FixFareTripModalComponent,
    CollapsibleFilterComponent,
    BookingStatusChangeConfirmationModalComponent,
    SurgePriceModalComponent,
    BookingVehicleFilterModalComponent,
    CancellationPolicyModalComponent,
    WalletHistoryModalComponent,
    AddNewCardComponent,
    AddAmountModalComponent,
    DriverListModelComponent,
    DateTimePickerModalComponent,
    BookingPaymentModalComponent,
    PromoCodeModalComponent,
    BookForOtherModalComponent,
    IncomingCallModalComponent,
    QueuedCallsWidgetComponent,
    RheroLogoComponent,
    RheroShellComponent,
    RheroPageHeaderComponent,
    RheroStateComponent
  ]
})
export class ModalComponentsModule {}
